
import React from "react";
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import responsibleGaming from '../data/images/responsible-gaming.png';
import gamblingAnonymous from '../data/images/rp-gamblersanonymous.png';
import rgc from '../data/images/rp-rgc.png';
import gamblingTherapy from '../data/images/rp-gamblingtherapy.png';

export default function ResponsibleGaming() {
    const locale = useSelector((state) => state.globalContent.data.locale);
    return (
        <Container fluid="lg" className="">
            <div className="responsible-gaming-wrapper">
                <div className="responsible-gaming-content-wrapper">
                    <h2 className="title white-100 mb-2">Responsible gaming</h2>
                    <p className="mb-4">We believe that it is our responsibility to our players and the gaming community to educate and provide support at the right moment.</p>
                    <div>
                        <a href="https://www.cherryspins.support/responsible-gaming" className="btn-secondary-outline">Learn more</a>
                    </div>
                    <div className="responsible-gaming-logos">
                        <img className="responsible-gaming-logo" src={gamblingAnonymous} />
                        <img className="responsible-gaming-logo" src={rgc} />
                        <img className="responsible-gaming-logo" src={gamblingTherapy} />
                    </div>
                </div>
                <div className="responsible-gaming-image-wrapper">
                    <img className="responsible-gaming-image" src={responsibleGaming} />
                </div>
            </div>
        </Container>
    )
}